/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { PrintExampleDto2 } from '@/api-sdk';
import { createContext } from '@lit/context';

export type UploadServiceContext =
  | {
      service: Promise<string> | Promise<PrintExampleDto2> | undefined;
      controller: AbortController;
    }
  | undefined;

export const uploadService =
  createContext<UploadServiceContext>('upload-service');
